import { sendEvent } from './api-services/facebookService'
import { getCookie } from './cookies'

const facebookPixel = {
  sendEvent: async (event_name, custom_data = {}) => {
    const user_data = {
      client_user_agent:
        typeof navigator !== 'undefined' ? navigator.userAgent : 'unknown',
      fbc: getCookie('_fbc') || null,
      fbp: getCookie('_fbp') || null,
    }

    try {
      await sendEvent({
        event_name,
        user_data,
        custom_data,
        event_source_url: window.location.href,
      })
    } catch (error) {
      console.error('Meta Pixel API error:', error)
    }
  },

  trackPageView: () => {
    facebookPixel.sendEvent('PageView')
  },

  trackViewContent: (page) => {
    facebookPixel.sendEvent('ViewContent', { page })
  },

  trackSchedule: (schedule) => {
    facebookPixel.sendEvent('Schedule', { schedule })
  },

  trackLead: (data) => {
    facebookPixel.sendEvent('Lead', data)
  },
}

export default facebookPixel
